import Sticky from "react-sticky-el"

import StickyNavHeader from "@/components/ProductDetail/v3/StickyHeader"
import { getPresetThumbnailUrl } from "@/utils/index"
import { useState } from "react"

const StickyHead = props => {
  const {
    isDiscontinued = "",
    showStickyHeader = "",
    stickyHeaderProps = {},
    discountedPrice = 0,
    price = 0,
    staticTexts = {},
    onAddToCart,
    isColorDiscontinued = "",
    addToCartProps = {},
    productOnStock = "",
    sku = "",
    customerFacingSKU = "",
    isComboSku = "",
    handleScroll,
    onAvailableColor = "",
    isRegionSoldOnline = "",
    productAnalyticsData = {},
    customerBrandName = "",
    replaceAddToCart = "",
    disableRatings = "",
    replaceAddToCartCtaLink = "",
    replaceAddToCartCtaLabel = "",
    linkNewTab = "",
    disableEcommerce = "",
    currencySign = "",
    swatchUrl = "",
    imagesData = {},
    presetConfigObject = {},
    assetAccountName = "",
    productPriceSpiderIncluded = "",
    isDynamicBundle = false,
    stickyHeaderImageURL = "",
    disableBundleAddToCart = false,
  } = props || {}
  const [sticky, setSticky] = useState(false)

  return (
    <Sticky
      onFixedToggle={() => setSticky(!sticky)}
      className="product-detail-page__sticky-wrapper"
      stickyClassName={"sticky sticky-pdp-page"}
    >
      {!isDiscontinued && sticky && showStickyHeader && (
        <StickyNavHeader
          {...stickyHeaderProps}
          currencySign={currencySign}
          price={discountedPrice > 0 ? discountedPrice : price}
          staticTexts={staticTexts}
          imgUrl={
            stickyHeaderImageURL ||
            getPresetThumbnailUrl(
              swatchUrl,
              imagesData[0]?.assetId,
              presetConfigObject,
              assetAccountName
            )
          }
          onAddToCart={onAddToCart}
          isDynamicBundle={isDynamicBundle}
          disableBundleAddToCart={disableBundleAddToCart}
          isDiscontinued={isDiscontinued}
          isColorDiscontinued={isColorDiscontinued}
          specialOrder={addToCartProps.specialOrder}
          backOrder={addToCartProps.backOrder}
          productStock={productOnStock}
          sku={sku}
          customerFacingSKU={customerFacingSKU}
          isComboSku={isComboSku}
          handleScroll={handleScroll}
          onAvailableColor={() => onAvailableColor()}
          productPriceSpiderIncluded={productPriceSpiderIncluded}
          isRegionSoldOnline={isRegionSoldOnline}
          analyticData={productAnalyticsData.stringProductInfo}
          customerBrandName={customerBrandName}
          replaceAddToCart={replaceAddToCart}
          disableRatings={disableRatings}
          replaceAddToCartCtaLink={replaceAddToCartCtaLink}
          replaceAddToCartCtaLabel={replaceAddToCartCtaLabel}
          linkNewTab={linkNewTab}
          disableEcommerce={disableEcommerce}
        />
      )}
    </Sticky>
  )
}

export default StickyHead
